import { jsx as _jsx } from "react/jsx-runtime";
import { ConfirmationModal } from "@air/component-confirmation-modal";
import { DateInput } from "@air/primitive-date-input";
import { parseAirDateToISO } from "@air/utilities";
import pluralize from "pluralize";
import { memo, useCallback, useMemo, useState } from "react";
export const BulkEditDateValueCustomFieldModal = /*#__PURE__*/ memo((param)=>{
    let { field, assetIds, boardIds, initialValues, onClose, onSave } = param;
    var _initialValues_;
    const allHaveSameValue = useMemo(()=>{
        var _initialValues_;
        const baseValue = (_initialValues_ = initialValues[0]) === null || _initialValues_ === void 0 ? void 0 : _initialValues_.dateValue;
        return initialValues.every((cf)=>cf.dateValue === baseValue);
    }, [
        initialValues
    ]);
    const originalValue = allHaveSameValue ? (_initialValues_ = initialValues[0]) === null || _initialValues_ === void 0 ? void 0 : _initialValues_.dateValue : undefined;
    const originalDateValue = originalValue ? parseAirDateToISO(originalValue) : undefined;
    const [dateValue, setDateValue] = useState(originalDateValue);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const onConfirm = useCallback(async ()=>{
        setIsSubmitting(true);
        const nextDateValue = dateValue === null || dateValue === void 0 ? void 0 : dateValue.toISOString();
        await onSave({
            assetIds,
            boardIds,
            baseCustomField: field,
            nextDateValue
        });
        onClose();
    }, [
        assetIds,
        boardIds,
        dateValue,
        field,
        onClose,
        onSave
    ]);
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        id: "bulk-edit-date-value-custom-field-modal",
        isOpen: true,
        title: "Edit ".concat(field.name),
        description: "Select a date to apply to the ".concat(pluralize("item", assetIds.length + boardIds.length, true), " you’ve selected."),
        ctaPrimaryText: "Save",
        onConfirm: onConfirm,
        isLoading: isSubmitting,
        isDisabled: dateValue === originalDateValue || isSubmitting,
        onDismiss: onClose,
        children: /*#__PURE__*/ _jsx("div", {
            className: "mt-4",
            children: /*#__PURE__*/ _jsx(DateInput, {
                size: "large",
                selected: dateValue,
                placeholderText: "Add a date",
                onChange: setDateValue,
                id: field.id,
                name: field.name,
                className: "w-full"
            })
        })
    });
});
BulkEditDateValueCustomFieldModal.displayName = "BulkEditDateValueCustomFieldModal";
